export default "__VITE_ASSET__D7X$q2t0__"